<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.fabricante"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(cnpj)="{item}">
                <template v-if="item.cnpj">
                    {{item.cnpj | cnpj}}
                </template>
            </template>

            <template v-slot:cell(conectasusFabricanteNome)="{item}">
                <template v-if="item.conectasusFabricanteNome">
                    {{ item.conectasusFabricanteNome }}
                </template>

                <rkm-button
                    v-else
                    @click="$refs.ModalVinculoConectaSusFabricante.open(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-fabricante"
                    color="primary"
                    small
                >
                    Vincular fabricante
                </rkm-button>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-fabricante"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-web-service-almoxarifado-cliente-fabricante"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalVinculoConectaSusFabricante
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalVinculoConectaSusFabricante"
        />
    </div>
</template>

<script>
// Components.
import ModalVinculoConectaSusFabricante from './components/vinculo-conecta-sus-fabricante/Modal'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import {error, repository} from '@/mixins'

export default {
    components: {ModalVinculoConectaSusFabricante},
    created() {
        this.repositories = {
            fabricante: this.getConectaSusRepository('webService.almoxarifado.cliente.fabricante'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'fabricante.nome', searchable: true, sortable: true},
            {key: 'cnpj', label: 'CNPJ', name: 'fabricante.cnpj', searchable: true, sortable: true},
            {
                key: 'conectasusFabricanteNome',
                label: 'Fabricante (ConectaSUS)',
                name: 'conectasusFabricante.nome',
                searchable: true,
                sortable: true
            },
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    filters: {
        cnpj: formats.formatCnpj,
    },
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-almoxarifado-cliente-fabricante-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.fabricante.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o fabricante?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>